const BASE_FONT_SIZE = 16;

const theme = {
  breakpoint: {
    small: 600,
    medium: 900,
    large: 1200,
  },
  color: {
    blue1: "#4eb9e8",
    blue2: "#419fcc",
    blue3: "#3782ad",
    blue4: "#286c99",
    blue5: "#184872",
    brandAccent: "#fabc3d",
    brandBright: "#f06542",
    brandDark: "#0d3b66",
    brandDull: "#f8f8f8",
    brandHover: "#f4f4f4",
    brandInfo: "#c7e9f5",
    brandLight: "#d1d1d1",
    brandSoft: "#9b9b9b",
    green1: "#60d394",
    green2: "#51aa89",
    green3: "#499082",
    green4: "#417e7c",
    green5: "#2e5b5f",
    indigo1: "#628fb8",
    maroon1: "#a45773",
    magenta1: "#e1629c",
    magenta2: "#af3881",
    magenta3: "#9a2e86",
    magenta4: "#914297",
    magenta5: "#74207a",
    orange1: "#f8a558",
    orangered1: "#f79468",
    red1: "#f06542",
    red2: "#d64848",
    red3: "#b94040",
    red4: "#802424",
    red5: "#652121",
    red6: "#3e1b12",
    yellow1: "#fac83d",
  },
  fontSize: {
    small: BASE_FONT_SIZE * 0.75,
    smallBase: BASE_FONT_SIZE * 0.875,
    base: BASE_FONT_SIZE,
    baseMedium: BASE_FONT_SIZE * 1.125,
    medium: BASE_FONT_SIZE * 1.25,
    mediumLarge: BASE_FONT_SIZE * 1.5,
    semiLarge: BASE_FONT_SIZE * 1.75,
    large: BASE_FONT_SIZE * 2,
    extraLarge: BASE_FONT_SIZE * 2.25,
    huge: BASE_FONT_SIZE * 2.5,
  },
  fontWeight: {
    thin: 100,
    extraLight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900,
  },
};

export default theme;
